import { render, staticRenderFns } from "./order-express.vue?vue&type=template&id=3cc3c9da&scoped=true&"
import script from "./order-express.vue?vue&type=script&lang=js&"
export * from "./order-express.vue?vue&type=script&lang=js&"
import style0 from "./order-express.vue?vue&type=style&index=0&id=3cc3c9da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3c9da",
  null
  
)

export default component.exports